import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  AppBar,
  Box,
  Button,
  Dialog,
  Divider,
  FormControlLabel,
  Grid,
  List,
  ListItem,
  ListItemText,
  Switch,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import { CreateEconomicActivityListForm } from "../economic-activity-list-forms/create-economic-activity-list-form/CreateEconomicActivityListForm";
import { useAppSelector } from "../../../../../../../application/states/hooks";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useEffect, useRef, useState } from "react";
import { useEconomicActivityListService } from "../../../../../../../use-cases/economic-activity-list";
import { theme } from "../../../../../../styles";
import { EconomicActivityListFilterPreview } from "../economic-activity-list-filter-preview";
import { EditEconomicActivityListForm } from "../economic-activity-list-forms/edit-economic-activity-list-form";
import { lighten } from "@mui/material/styles";
import { darken } from "@mui/material/styles";

export const DialogEconomicActivityList = () => {
  // slices
  const openEconomicActivityListDialog = useAppSelector(
    (state) => state.economicActivityList.openEconomicActivityListDialog,
  );
  const economicActivityList = useAppSelector(
    (state) => state.economicActivityList,
  );

  const { company } = useAppSelector((state) => state.company);

  const projectState = useAppSelector((state) => state.project);
  const user = useAppSelector((state) => state.user);

  // states locais
  const [purge, setPurge] = useState(false);

  // services
  const {
    //open form
    setOpenEconomicActivityListDialog,
    setOpenCreateEconomicActivityListForm,
    setOpenEditEconomicActivityListForm,
    resetEconomicActivityLists,
    //create
    resetCreateEconomicActivityList,
    setEconomicActivityLists,
    setSearchTerm,
    setSelectList,
    setUnselectList,
    setSelectAllEconomicActivityLists,
    //edit
    setSelectEconomicActivityListToEdit,
    resetEditEconomicActivityListCnae,
    editStatusEconomicActivityList,
  } = useEconomicActivityListService();  
  const hasFetchedRef = useRef(false);

  useEffect(() => {
    setEconomicActivityLists(user.id);
    if (openEconomicActivityListDialog && !hasFetchedRef.current) {
      const hasNormalFilter =
        (projectState.selectedFilter?.economicActivityList?.length ?? 0) > 0;
      const hasPurgeFilter =
        (projectState.selectedFilter?.purgeEconomicActivityLists?.length ?? 0) >
        0;

      if (hasNormalFilter || hasPurgeFilter) {
        economicActivityList.economicActivityLists.forEach((listaDoBanco) => {
          if (hasNormalFilter) {
            const listaEncontradaNormal =
              projectState.selectedFilter?.economicActivityList?.find(
                (listaFiltro) => listaFiltro.id === listaDoBanco.id,
              );

            if (listaEncontradaNormal) {
              setSelectList(listaDoBanco.id, false);
            }
          }

          // Procura nos filtros purge
          if (hasPurgeFilter) {
            const listaEncontradaPurge =
              projectState.selectedFilter?.purgeEconomicActivityLists?.find(
                (listaFiltro) => listaFiltro.id === listaDoBanco.id,
              );

            if (listaEncontradaPurge) {
              setSelectList(listaDoBanco.id, true);
            }
          }
        });
      } else {
      }

      hasFetchedRef.current = true;
    }

    if (!openEconomicActivityListDialog) {
      hasFetchedRef.current = false;
    }
  }, [openEconomicActivityListDialog]); // ✅ SÓ DEPENDE DISSO!

  const handleClose = () => {
    resetEconomicActivityLists();
    setOpenEconomicActivityListDialog(false);
  };

  return (
    <>
      <CreateEconomicActivityListForm />
      <EditEconomicActivityListForm />

      <Dialog
        fullScreen
        open={openEconomicActivityListDialog}
        onClose={() => {
          handleClose();
        }}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <Typography
              sx={{ ml: 2, flex: 1 }}
              variant="h6"
              component="div"
              textTransform={"uppercase"}
            >
              Selecionar lista de atividades econômicas
            </Typography>
            <Button
              autoFocus
              color="inherit"
              onClick={() => {
                handleClose();
              }}
            >
              Fechar
            </Button>
          </Toolbar>
        </AppBar>

        <Box p={3}>
          <Grid container spacing={3} mb={3}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Buscar lista de CNAEs por nome"
                value={economicActivityList.searchTerm || ""}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  console.error(
                    "Search term updated: ",
                    economicActivityList.searchTerm,
                  ); 
                }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={2}>
              <FormControlLabel
                control={
                  <Switch
                    checked={purge}
                    onChange={(e) => {
                      setPurge(e.target.checked);
                    }}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                }
                label={purge ? "Não incluir esta lista" : "Incluir esta lista"}
              />
            </Grid>
          </Grid>

          <Box pl={3}>
            <form onSubmit={(e) => e.preventDefault()}>
              <Grid container spacing={2}>
                <Grid item xs={3}>
                  <Button
                    fullWidth
                    onClick={(e) => {
                      setOpenCreateEconomicActivityListForm(true);
                      resetCreateEconomicActivityList();
                    }}
                    startIcon={<AddIcon />}
                  >
                    Criar nova lista de CNAEs
                  </Button>
                </Grid>

                {/* <Grid item xs={2}>
                  <Button
                    sx={{
                      "&:hover": {
                        color:
                          company?.resale === true || company?.resaleId
                            ? theme.palette.primary.contrastText
                            : theme.palette.primary.contrastText,
                        backgroundColor:
                          company?.resale === true || company?.resaleId
                            ? darken(theme.palette.primary.main, 0.2)
                            : lighten(theme.palette.primary.main, 0.2),
                        cursor: "default",
                      },
                    }}
                    variant="contained"
                    onClick={() => {
                      setSelectAllEconomicActivityLists();
                    }}
                  >
                    Incluir todas as listas
                  </Button>
                </Grid> */}

              </Grid>
            </form>
          </Box>

          <Grid container spacing={3}>
            {/* Lista de listas disponíveis (à esquerda) */}
            <Grid item xs={12} md={6}>
              {economicActivityList.economicActivityLists?.length > 0 ? (
                <List>
                  {economicActivityList.economicActivityLists
                    .filter((list) => {
                      // Aplica o mesmo filtro aqui também
                      const searchTermLower =
                        economicActivityList.searchTerm?.toLowerCase() || "";
                      return (
                        searchTermLower === "" ||
                        list.name.toLowerCase().includes(searchTermLower)
                      );
                    })
                    .map((list) => (
                      <Box key={list.id}>
                        <ListItem
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            px: 2,
                            py: 1.5,
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            if (list.active === true) {
                              setSelectList(list.id, purge);
                            }
                            // else {
                            //   setUnselectList(list.id, purge);
                            // }
                          }}
                        >
                          <Box sx={{ flex: 1, minWidth: 0 }}>
                            <ListItemText
                              primary={list.name}
                              secondary={`${Array.isArray(list.economicActivityList) ? list.economicActivityList.length : 0} CNAEs`}
                              primaryTypographyProps={{ noWrap: true }}
                              secondaryTypographyProps={{ noWrap: true }}
                            />
                          </Box>

                          {/* Ações: Editar / Excluir */}
                          <Box display="flex" gap={1} ml={1}>
                            <Button
                              size="small"
                              startIcon={<EditIcon />}
                              disabled={list.active === false}
                              onClick={(e) => {
                                e.stopPropagation();
                                resetCreateEconomicActivityList();
                                resetEditEconomicActivityListCnae();
                                setSelectEconomicActivityListToEdit(list.id);
                                setOpenEditEconomicActivityListForm(true);
                              }}
                              color="primary"
                            >
                              Editar
                            </Button>

                            {/* Container para isolar o evento do Switch */}
                            <div onClick={(e) => e.stopPropagation()}>
                              <Switch
                                checked={list.active}
                                onChange={(e) => {
                                  editStatusEconomicActivityList({
                                    active: !list.active,
                                    id: list.id,
                                  });
                                }}
                                inputProps={{ "aria-label": "controlled" }}
                              />
                            </div>
                          </Box>
                        </ListItem>
                        <Divider
                          sx={{ borderColor: theme.palette.primary.main }}
                        />
                      </Box>
                    ))}
                </List>
              ) : (
                <Box textAlign="center" py={4}>
                  <Typography color="textSecondary" variant="body1">
                    {economicActivityList.searchTerm
                      ? "Nenhuma lista encontrada com esse nome."
                      : "Nenhuma lista de ocupações salva ainda."}
                  </Typography>
                </Box>
              )}
            </Grid>

            {/* Painel de listas selecionadas (à direita) */}
            {(projectState.selectedFilter?.economicActivityList ||
              projectState.selectedFilter?.purgeEconomicActivityLists) &&
            ((projectState.selectedFilter?.economicActivityList?.length ?? 0) >
              0 ||
              (projectState.selectedFilter?.purgeEconomicActivityLists
                ?.length ?? 0) > 0) ? (
              <Grid item xs={12} md={6}>
                <Box px={3}>
                  <Accordion defaultExpanded>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography
                        variant="h5"
                        color="primary"
                        fontWeight="bold"
                        textTransform="uppercase"
                      >
                        Listas selecionadas
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <EconomicActivityListFilterPreview />
                    </AccordionDetails>
                  </Accordion>
                </Box>
              </Grid>
            ) : (
              <Box py={6} px={9} sx={{ textAlign: "center" }}>
                <Typography color="textSecondary" variant="body1">
                  Nenhuma lista de CNAEs selecionada para pequisa.
                </Typography>
              </Box>
            )}
          </Grid>
        </Box>
      </Dialog>
    </>
  );
};
